/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisiteOverviewCtrl
 * @description A report of sales data and other information for all companies
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisiteOverviewCtrl', ["Budgets", "comparetime", "$filter", "multisite", "PosVoids", "ReportSales", "ReportOrders", "$q", "reporttime", "$scope", "title", "userinfo", function(Budgets, comparetime, $filter, multisite, PosVoids,
  ReportSales, ReportOrders, $q, reporttime, $scope, title, userinfo) {
  title.set('Overview');
  multisite.setMultisite(true);

  $scope.results = [];
  $scope.graphRows = [];
  $scope.compare = comparetime.time() !== null;
  $scope.graphColumns = [
    {label: 'Time', type: 'string', key: 'time'}
  ];

  var salesResults = {};
  var ordersResults = {};
  var budgetResults = {};
  var voidsResults = {};
  var salesCompare = {};
  var ordersCompare = {};
  var budgetsCompare = {};
  var voidsCompare = {};

  var colourIndex = 0;

  var createResultLine = function(company) {
    // we don't want to add companies to the resultset multiple times, so check the restuls array and only add if it's a new companyId
    var newCompany = true;
    angular.forEach($scope.results, function(result) {
      if (result.companyId == company.id) {
        newCompany = false;
        result.show = '1';
      }
    });

    var newColumnRequired = true;
    angular.forEach($scope.graphColumns, function(col) {
      if (col.key == company.id.toString()) {
        newColumnRequired = false;
      }
    });
    if (newColumnRequired) {
      $scope.graphColumns.push({label: company.name, type: 'number', key: company.id.toString(), filter: 'currency'});
    }

    if (newCompany) {
      $scope.results.push({
        companyId: company.id,
        show: '1',
        name: company.name,
        colorClass: 'graph-default-color-' + colourIndex++,
        orders: null,
        ordersCompare: null,
        sales: null,
        salesCompare: null,
        discounts: null,
        discountsCompare: null,
        voids: null,
        voidsCompare: null,
        budgets: null,
        budgetsCompare: null
      });
    }
  };

  var buildReport = function() {
    angular.forEach(userinfo.companies(), function(company) {
      if (multisite.isCompanyDisabled(company.id)) {
        angular.forEach($scope.results, function(result) {
          if (result.companyId == company.id) {
            result.show = '0';

            // also remove the data series from the main googleChart
            var spliceIndex = $scope.graphColumns.findIndex(function(col) {
              return col.key === result.companyId.toString();
            });
            if (spliceIndex != -1) {
              $scope.graphColumns.splice(spliceIndex, 1);
            }
          }
        });
        $scope.$emit('dataTableUpdate');
        return;
      }

      // Fetch any missing results
      if (!salesResults[company.id]) {
        salesResults[company.id] = ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
      }
      if (!ordersResults[company.id]) {
        ordersResults[company.id] = ReportOrders.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
      }
      if (!budgetResults[company.id]) {
        budgetResults[company.id] = Budgets.getAll(reporttime.start(), reporttime.end(), company.id);
      }
      if (!voidsResults[company.id]) {
        voidsResults[company.id] = PosVoids.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
      }

      if ($scope.compare) {
        if (!salesCompare[company.id]) {
          salesCompare[company.id] = ReportSales.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
        }
        if (!ordersCompare[company.id]) {
          ordersCompare[company.id] = ReportOrders.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
        }
        if (!budgetsCompare[company.id]) {
          budgetsCompare[company.id] = Budgets.getAll(comparetime.start(), comparetime.end(), company.id);
        }
        if (!voidsCompare[company.id]) {
          voidsCompare[company.id] = PosVoids.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
        }
      }

      salesResults[company.id].then(function(salesResult) {
        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.sales = $filter('sumof')(salesResult, 'invoices');
            resultLine.discounts = $filter('sumof')(salesResult, 'discounts');
          }
        });

        var runningTotal = 0;
        angular.forEach($scope.graphRows, function(row, index) {
          if (salesResult[index] && salesResult[index].invoices) {
            runningTotal += salesResult[index].invoices;
          }
          row[company.id] = runningTotal;
        });

        $scope.$emit('update.googleChart');
      });

      ordersResults[company.id].then(function(ordersResult) {
        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.orders = $filter('sumof')(ordersResult, 'amount');
          }
        });
      });

      budgetResults[company.id].then(function(budgetResult) {
        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.budgets = $filter('sumof')(budgetResult, 'amount');
          }
        });
      });

      voidsResults[company.id].then(function(voidsResult) {
        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.voids = $filter('sumof')(voidsResult, 'voidAmount');
          }
        });
      });

      if (salesCompare[company.id]) {
        salesCompare[company.id].then(function(salesResult) {
          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.salesCompare = $filter('sumof')(salesResult, 'invoices');
              resultLine.discountsCompare = $filter('sumof')(salesResult, 'discounts');
            }
          });
        });

      }

      if (ordersCompare[company.id]) {
        ordersCompare[company.id].then(function(ordersResult) {
          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.ordersCompare = $filter('sumof')(ordersResult, 'amount');
            }
          });
        });
      }

      if (budgetsCompare[company.id]) {
        budgetsCompare[company.id].then(function(budgetResult) {
          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.budgetsCompare = $filter('sumof')(budgetResult, 'amount');
            }
          });
        });
      }

      if (voidsCompare[company.id]) {
        voidsCompare[company.id].then(function(voidsResult) {
          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.voidsCompare = $filter('sumof')(voidsResult, 'voidAmount');
            }
          });
        });
      }

      createResultLine(company);
    });

    $scope.$emit('dataTableUpdate');
  };

  // initialize the chart rows
  for (var iter = moment(reporttime.start()); iter.isBefore(reporttime.end()); iter.mNextIteration(reporttime.reportType())) {
    $scope.graphRows.push({time: iter.format(reporttime.getFormatString())});
  }

  angular.forEach(userinfo.companies(), function(company) {
    if (multisite.isCompanyDisabled(company.id)) {
      angular.forEach($scope.results, function(result) {
        if (result.companyId == company.id) {
          result.show = '0';
        }
      });
      return;
    }

    salesResults[company.id] = ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
    ordersResults[company.id] = ReportOrders.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
    budgetResults[company.id] = Budgets.getAll(reporttime.start(), reporttime.end(), company.id);
    voidsResults[company.id] = PosVoids.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);

    if ($scope.compare) {
      salesCompare[company.id] = ReportSales.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
      ordersCompare[company.id] = ReportOrders.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
      budgetsCompare[company.id] = Budgets.getAll(comparetime.start(), comparetime.end(), company.id);
      voidsCompare[company.id] = PosVoids.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
    }

    createResultLine(company);
  });

  $scope.loading = $q.race(salesResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
